import React, { useMemo } from 'react'
import { useParams } from 'react-router-dom';
import { translate } from '../utils/translator';
import { useCartContext } from '../customHooks/useCart';
import RiskGroupedProductList from './RiskGroupedProductList';
import { EXTERNAL_PHARMACY_INTEGRATIONS_FLOWS } from '../utils/consts';
import CartViewSummary from './CartViewSummary';
import CartViewSummaryDE from './CartViewSummaryDE';
import { shouldShowPriceBreakdown } from '../utils/helpers';
type Props = {
  className?: string
  setRxProductFinalPrice?: (price: number) => void //TODO: Delete it when old shipping is dead
  shippingFee?: number 
  isExpressShipping?: boolean
}



const OTCCartView: React.FC<Props> = ({ className , setRxProductFinalPrice, shippingFee, isExpressShipping=false }) => {

  const { language } = useParams()
  const { getCart } = useCartContext();
  const cart = getCart();
  const { country } = useParams();

  const Products = useMemo(() => {
    return cart.products
  }, [cart.products])

  

  return (
    <>  
    <div id='cart-view-container' className={`flex flex-col bg-white px-5 pt-2 rounded-[16px] h-fit gap-6 ${className} `}>

      <div id='cart-view-products-container' style={{ borderBottom: "1px dashed #0A9281" }} className='flex flex-col gap-2'>
      <h2 className='text-base font-roboto font-semibold text-[#0D2C54] mt-2'>{translate(language, "default", "OrderWindow/non_prescription_products")}</h2>
         {/* OTC (non-prescription) Product rows  */}
        <RiskGroupedProductList products={Products} />
      </div>

      
    </div>

    {/* Calculations Summary */}
    <div className={`flex flex-col bg-white px-5 pb-2 pt-4 rounded-[16px] h-fit gap-6 ${className} `}>
      {!shouldShowPriceBreakdown(country) ? (
        <CartViewSummary setRxProductFinalPrice={setRxProductFinalPrice} shippingFee={shippingFee} isExpressShipping={isExpressShipping} isOtcOnly={true}/>
        ) : (
          <CartViewSummaryDE setRxProductFinalPrice={setRxProductFinalPrice} shippingFee={shippingFee} isExpressShipping={isExpressShipping} />
      )}
    </div>

    {/* Images disclaimer */}
    {(!EXTERNAL_PHARMACY_INTEGRATIONS_FLOWS.includes(cart.flow || "")) ?
      <p
        id='cart-view-images-disclaimer'
        className='text-xs text font-roboto text-center text-[#98a0af] mt-4'>*{translate(language, "default", "OrderWindow/image_disclaimer")}</p>
      :
      null
    }

    </>
  )
}

export default OTCCartView